module.exports = __webpack_public_path__ + "img/empty-icon.faa42b05.png";